module.exports = __webpack_public_path__ + "media/images/cells-8e89526d26134019d03053d7751d1f54.svg";